import { useParams } from "react-router";
import { gql, useQuery } from "@apollo/client";
import styles from "./index.module.scss";
import AdpForm from "../../../components/ADP/AdpForm";
import Loader from "../../../components/Loader";
import ClientFileProvider from "../../../contexts/ClientFileProvider";

const GET_CLIENT_FILE = gql`
  query GetClientFile($id: ID!) {
    clientFile(id: $id) {
      id
      status
      signing_authorizer {
        id
        first_name
        last_name
      }
      signing_sales_rep {
        id
        first_name
        last_name
      }
      client {
        id
        first_name
        last_name
        social_assistance
        health_card
        health_card_version
        birth_date
        long_term_care_home
        sex
        cep
        address {
          address_1
          address_2
          unit_number
          street_number
          street_name
          lot
          business_phone
          business_phone_ext
          postal_code
          city
          province
          phone
          fax
        }
        agent {
          unit_number
          street_number
          street_name
          lot
          business_phone
          business_phone_ext
          postal_code
          city
          province
          phone
          fax
        }
        authorizers {
          id
          first_name
          last_name
          role {
            type
            name
          }
        }
        sales_reps {
          id
          first_name
          last_name
          role {
            type
            name
          }
          locations {
            id
            name
            adp_auth_num
          }
          cep
        }
      }
      client_form {
        id
        form_data
        updated_at
      }
      ds_envelope_id
      # file_events
      client_signature {
        name
        url
      }
      justification {
        name
        url
      }
      letter_of_rationale {
        name
        url
      }
      quote {
        name
        url
      }
      confirmation_of_benefits {
        name
        url
      }
      other_supporting_documents {
        name
        url
      }
      other_supporting_documents_alt {
        name
        url
      }
      wet_signature {
        name
        url
      }
      ds_signed_form {
        name
        url
      }
      ds_signed_form_original {
        name
        url
      }
      form_xml {
        name
        url
      }
      locked_by {
        id
        first_name
        last_name
      }
      locked_at
    }
  }
`;

const FormPage = () => {
  const params = useParams<{ client_id: string; file_id: string }>();

  // Get file, form and client data
  // Note: not currently verifying that the client id in the URL is linked to the file that is fetched
  const { loading, error, data } = useQuery(GET_CLIENT_FILE, {
    fetchPolicy: "network-only",
    variables: {
      id: params.file_id,
    },
  });

  if (loading)
    return <Loader heading="Loading ADP Form..." className={styles.loader} />;

  // ToDo
  if (error) return <p>Error: {error.message}</p>;

  return (
    <ClientFileProvider clientFile={data.clientFile}>
      <AdpForm />
    </ClientFileProvider>
  );
};

export default FormPage;
